import { I18nCode } from './I18n-code';
import { CdxDocument } from './cdx-document';

export enum TaskState {
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED'
}
export enum ProcessState {
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED'
}

export class CdxTask extends CdxDocument {
   cdx_wkf: CdxWkf;
   task_action_state?: TaskActionState;
}

export class CdxProcess {
  activity_type: ActivityType;
  execution_id: string;
  process_instance_id: string;
  deployment_id: string;
  process_def: I18nCode;
  task_instance_id: string;
  task_def: I18nCode;
  task_state: TaskState;
  process_state: ProcessState;
}

export class Assignation {
  assignee: string;
  candidate_groups: string[];
  candidate_user: string[];
}

export class CdxWkf {
  cdx_datas: {[key: string]: any};
  cdx_process: CdxProcess;
  sub_task: {[key: string]: any};
  assignation: Assignation;
}

export enum ActivityType {
  MULTI_INSTANCE_BODY = 'multiInstanceBody',
  GATEWAY_INCLUSIVE = 'inclusiveGateway',
  GATEWAY_PARALLEL = 'parallelGateway',
  GATEWAY_COMPLEX = 'complexGateway',
  GATEWAY_EVENT_BASED = 'eventBasedGateway',
  TASK = 'task',
  TASK_SCRIPT = 'scriptTask',
  TASK_SERVICE = 'serviceTask',
  TASK_BUSINESS_RULE = 'businessRuleTask',
  TASK_MANUAL_TASK = 'manualTask',
  TASK_USER_TASK = 'userTask',
  TASK_SEND_TASK = 'sendTask',
  TASK_RECEIVE_TASK = 'receiveTask',
  SUB_PROCESS = 'subProcess',
  SUB_PROCESS_AD_HOC = 'adHocSubProcess',
  CALL_ACTIVITY = 'callActivity',
  TRANSACTION = 'transaction',
  BOUNDARY_TIMER = 'boundaryTimer',
  BOUNDARY_MESSAGE = 'boundaryMessage',
  BOUNDARY_SIGNAL = 'boundarySignal',
  BOUNDARY_COMPENSATION = 'compensationBoundaryCatch',
  BOUNDARY_ERROR = 'boundaryError',
  BOUNDARY_ESCALATION = 'boundaryEscalation',
  BOUNDARY_CANCEL = 'cancelBoundaryCatch',
  BOUNDARY_CONDITIONAL = 'boundaryConditional',
  START_EVENT = 'startEvent',
  START_EVENT_TIMER = 'startTimerEvent',
  START_EVENT_MESSAGE = 'messageStartEvent',
  START_EVENT_SIGNAL = 'signalStartEvent',
  START_EVENT_ESCALATION = 'escalationStartEvent',
  START_EVENT_COMPENSATION = 'compensationStartEvent',
  START_EVENT_ERROR = 'errorStartEvent',
  START_EVENT_CONDITIONAL = 'conditionalStartEvent',
  INTERMEDIATE_EVENT_CATCH = 'intermediateCatchEvent',
  INTERMEDIATE_EVENT_MESSAGE = 'intermediateMessageCatch',
  INTERMEDIATE_EVENT_TIMER = 'intermediateTimer',
  INTERMEDIATE_EVENT_LINK = 'intermediateLinkCatch',
  INTERMEDIATE_EVENT_SIGNAL = 'intermediateSignalCatch',
  INTERMEDIATE_EVENT_CONDITIONAL = 'intermediateConditional',
  INTERMEDIATE_EVENT_THROW = 'intermediateThrowEvent',
  INTERMEDIATE_EVENT_SIGNAL_THROW = 'intermediateSignalThrow',
  INTERMEDIATE_EVENT_COMPENSATION_THROW = 'intermediateCompensationThrowEvent',
  INTERMEDIATE_EVENT_MESSAGE_THROW = 'intermediateMessageThrowEvent',
  INTERMEDIATE_EVENT_NONE_THROW = 'intermediateNoneThrowEvent',
  INTERMEDIATE_EVENT_ESCALATION_THROW = 'intermediateEscalationThrowEvent',
  END_EVENT_ERROR = 'errorEndEvent',
  END_EVENT_CANCEL = 'cancelEndEvent',
  END_EVENT_TERMINATE = 'terminateEndEvent',
  END_EVENT_MESSAGE = 'messageEndEvent',
  END_EVENT_SIGNAL = 'signalEndEvent',
  END_EVENT_COMPENSATION = 'compensationEndEvent',
  END_EVENT_ESCALATION = 'escalationEndEvent',
  END_EVENT_NONE = 'noneEndEvent'
}

export enum TASK_ACTION_STATE_VALUE {
  WORKING = 'working',
  DONE = 'done',
  ERROR = 'error'
}
export class TaskActionState {
  constructor(public stateValue: string, public errorDescription?: string) {}
}